module.exports = __webpack_public_path__ + "static/img/2019.2bc72a9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/dynamic/events/2019.png
// module id = dXEJ
// module chunks = 1